// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/service/ServiceAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants, serviceConstants} from "../../constants";
import {serviceAddItem, serviceSetItem, serviceGetItem} from "../../actions/serviceActions";
import {list as areaList} from '../../containers/area/AreaListPage';
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.service.getItem,
        userValue : state.app.currentUser,
        areaList  : state.area.areaList,

    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title'    : values.title,
            'cityId'   : values.cityId,
            'stateId'  : values.stateId,
            'price'    : parseInt(values.price),
            'commuting': parseInt(values.commuting),
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('service-type', formData).then(res => {
            dispatch(serviceAddItem(res.data));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addService'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title'    : values.title,
            'cityId'   : values.city._id,
            'stateId'  : values.state._id,
            'price'    : parseInt(values.price),
            'commuting': parseInt(values.commuting)
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('service-type/'+id, formData).then(editRes => {
            dispatch(serviceSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('service-type/'+id).then(serviceInfo => {
            dispatch(serviceGetItem(serviceInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
